var UitkDateRangeGetCenterScrollDistance = function (selectedDateOffset, selectedDateWidth, dateRangeWidth) {
  return selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2 > 0 ? selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2 : 0;
};
var UitkDateRangeGetSelectedDateScrollCenterDistance = function (dateRangeEl, selectedDateIndex) {
  if (!dateRangeEl) {
    return 0;
  }
  var selectedDateEl = dateRangeEl.querySelectorAll('li')[selectedDateIndex];
  var dateRangePxWidth = dateRangeEl.offsetWidth;
  var selectedDatePxWidth = selectedDateEl && selectedDateEl.offsetWidth;
  var selectedDatePxOffset = selectedDateEl && selectedDateEl.offsetLeft;
  return UitkDateRangeGetCenterScrollDistance(selectedDatePxOffset, selectedDatePxWidth, dateRangePxWidth);
};
export { UitkDateRangeGetCenterScrollDistance, UitkDateRangeGetSelectedDateScrollCenterDistance };